// File: src/components/Admin/InternetServicesDebug.tsx
import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, Alert, CircularProgress } from '@mui/material';
import api from '../../services/api';

const InternetServicesDebug: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);
  const [data, setData] = useState<any>(null);
  const [apiCalls, setApiCalls] = useState<string[]>([]);

  useEffect(() => {
    const testApi = async () => {
      const calls: string[] = [];
      
      try {
        // Test 1: Get all services
        calls.push('Testing GET /endpoints/internetservices...');
        const response = await api.get('/endpoints/internetservices');
        calls.push(`✓ Success: Got ${response.data.data?.length || 0} services`);
        setData(response.data.data);
        
      } catch (err: any) {
        calls.push(`✗ Error: ${err.message}`);
        calls.push(`  Status: ${err.response?.status}`);
        calls.push(`  Response: ${JSON.stringify(err.response?.data)}`);
        setError(err);
      }
      
      setApiCalls(calls);
      setLoading(false);
    };
    
    testApi();
  }, []);

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>Internet Services Debug</Typography>
      
      <Paper sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>API Test Results:</Typography>
        {apiCalls.map((call, index) => (
          <Typography key={index} variant="body2" sx={{ fontFamily: 'monospace' }}>
            {call}
          </Typography>
        ))}
      </Paper>

      {loading && (
        <Box display="flex" alignItems="center" gap={2}>
          <CircularProgress size={20} />
          <Typography>Testing API...</Typography>
        </Box>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          Error Details:
          <pre style={{ fontSize: '12px', overflow: 'auto' }}>
            {JSON.stringify(error, null, 2)}
          </pre>
        </Alert>
      )}

      {data && (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>Data Retrieved:</Typography>
          <pre style={{ fontSize: '12px', overflow: 'auto', maxHeight: '400px' }}>
            {JSON.stringify(data, null, 2)}
          </pre>
        </Paper>
      )}
    </Box>
  );
};

export default InternetServicesDebug;